module.exports = __webpack_public_path__ + "img/Pic_Text_DDZ_Title.dc94792b.png";